import React from 'react';
export function Price() {
  return <section className="bg-[#0F172A] py-20 px-5 text-center relative overflow-hidden" id="comprar" data-id="element-104">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#22C55E] via-[#F97316] to-transparent" data-id="element-105" />

      <div className="max-w-[780px] mx-auto" data-id="element-106">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-107" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-white tracking-tight leading-[1.2]" data-id="element-108">
          Invertí menos que en 5 barritas de quiosco
        </h2>

        <p className="text-center text-[#94A3B8] text-[15px] mb-9" data-id="element-109">
          Y fabricá miles por el resto de tu vida
        </p>

        <div className="bg-[#1E293B] border-[1.5px] border-[rgba(34,197,94,0.25)] rounded-[28px] py-12 px-9 max-w-[480px] mx-auto shadow-[0_32px_80px_rgba(0,0,0,0.4),inset_0_1px_0_rgba(255,255,255,0.04)] relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:bg-gradient-to-r before:from-transparent before:via-[#22C55E] before:to-transparent" data-id="element-110">
          <p className="text-[17px] text-[#64748B] line-through mb-1.5" data-id="element-111">
            Valor real: $53.000
          </p>

          <p className="font-montserrat text-[72px] font-black text-white leading-none my-[10px] tracking-tight" data-id="element-112">
            <span className="text-2xl font-bold text-[#F97316] align-super" data-id="element-113">
              $
            </span>
            16.990
          </p>

          <p className="text-[13px] text-[#64748B] mb-6 tracking-[0.3px]" data-id="element-114">
            Pago único — Sin cuotas mensuales — Acceso inmediato
          </p>

          <div className="bg-[rgba(249,115,22,0.12)] text-[#F97316] border border-[rgba(249,115,22,0.35)] font-montserrat text-xs font-bold tracking-[1.5px] uppercase py-[9px] px-5 rounded-md mb-7 inline-block" data-id="element-115">
            ⚡ OFERTA DE LANZAMIENTO — Solo por hoy
          </div>

          <a href="#" className="block text-center bg-[#F97316] text-white font-montserrat text-[15px] font-extrabold uppercase tracking-[1.5px] py-[18px] px-11 rounded-lg border-none cursor-pointer no-underline transition-all duration-[0.25s] hover:bg-[#C2410C] hover:shadow-[0_8px_32px_rgba(249,115,22,0.45)] hover:-translate-y-0.5 active:translate-y-0" style={{
          animation: 'pulse-cta 2.5s ease infinite'
        }} data-id="element-116">
            AGREGAR AL CARRITO &gt;&gt;
          </a>
        </div>
      </div>
    </section>;
}